/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const COLLECTION_STATUSES = ['published', 'draft', 'deleted', 'locked'] as const;

export const collectionStatusSchema = z.enum(COLLECTION_STATUSES);

export type ICollectionStatus = z.infer<typeof collectionStatusSchema>;
